<form [formGroup]="exitLinkGroup" class="link-form">
  <label>{{ 'CUSTOMIZE_PARTNER.EXIT_LINK.LINK_TEXT_LABEL' | translate }}</label>
  <forms-input
    name="linkText"
    [control]="exitLinkGroup.get(['linkText'])"
    placeholder="{{ 'CUSTOMIZE_PARTNER.EXIT_LINK.BACK_TO_BA' | translate }}"
  ></forms-input>
  <mat-radio-group [formControl]="exitLinkGroup.get(['selectedLink'])">
    <mat-radio-button value="default">
      {{ 'CUSTOMIZE_PARTNER.EXIT_LINK.BA_OPTION' | translate }}
    </mat-radio-button>
    <mat-radio-button value="customize">
      {{ 'CUSTOMIZE_PARTNER.EXIT_LINK.CUSTOM_OPTION' | translate }}
    </mat-radio-button>
  </mat-radio-group>
  <forms-input
    [control]="exitLinkGroup.get(['customUrl'])"
    placeholder="{{ 'CUSTOMIZE_PARTNER.EXIT_LINK.PASTE_URL' | translate }}"
  ></forms-input>
  <forms-input
    [control]="exitLinkGroup.get(['logoutUrl'])"
    placeholder="{{ 'CUSTOMIZE_PARTNER.EXIT_LINK.PASTE_URL' | translate }}"
  ></forms-input>
</form>
<button mat-button (click)="save()">
  {{ 'CUSTOMIZE_PARTNER.SHARED.APPLY_CHANGES' | translate }}
</button>
<button mat-button (click)="restoreDefault()" color="warn">
  {{ 'CUSTOMIZE_PARTNER.SHARED.RESTORE_DEFAULTS' | translate }}
</button>
